export const TYPOGRAPHY_STYLE_QUERY_KEY = 'typographyStyleQueryKey';
